export default __webpack_public_path__ + "static/1890_1900-ca1dbe74a637317031f261986734f4bf.jpg";